import * as React from "react";
import { useInstantSearch } from "react-instantsearch";
import { Tabs, Tab } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { getResultsByIndex } from "../../../../Algolia/utils/Algolia/utils/get-results-by-index.js";
function lowercaseAndCapitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
const SearchTabs = ({
  setActiveTabIndex,
  activeTabIndex,
  indexes,
  productIndex
}) => {
  const { scopedResults } = useInstantSearch();
  const { getLabel } = useIntl();
  const productSuggestions = getResultsByIndex(scopedResults, productIndex.name);
  const contentSuggestions = indexes.contentIndex && getResultsByIndex(scopedResults, indexes.contentIndex.name);
  const productLabel = lowercaseAndCapitalize(getLabel("search.suggestions.products.title"));
  const contentLabel = lowercaseAndCapitalize(getLabel("search.suggestions.content.title"));
  return /* @__PURE__ */ React.createElement(Tabs, { onChange: setActiveTabIndex, activeTabIndex }, /* @__PURE__ */ React.createElement(Tab, { label: `${productLabel} (${productSuggestions?.nbHits ?? 0})` }), /* @__PURE__ */ React.createElement(Tab, { label: `${contentLabel} (${contentSuggestions?.nbHits ?? 0})` }));
};
export {
  SearchTabs,
  SearchTabs as default
};
//# sourceMappingURL=SearchTabs.js.map
